import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick", "className"];
import { forwardRef } from 'react';
import useUsageTracker from '../hooks/useUsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackedButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      onClick,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackNavClick
  } = useUsageTracker();
  const trackedOnClick = evt => {
    trackNavClick(evt);
    if (onClick) {
      return onClick(evt);
    }
    return undefined;
  };
  return /*#__PURE__*/_jsx("button", Object.assign({
    className: className,
    onClick: trackedOnClick,
    ref: ref
  }, rest, {
    children: children
  }));
});
TrackedButton.displayName = 'TrackedButton';
export default TrackedButton;